<template>
    <v-footer
            :color="footerColour"
    >
        <v-container>
            <v-row>
                <v-col xs="12" sm="12" md="6">
                    <div class="copyright">
                        <span class="white--text">&copy; {{ brandName }} Ltd {{ new Date().getFullYear() }}</span>
                    </div>
                    <div class="d-flex flex-column flex-sm-row justify-left align-left" style="width: 100%">
                        <div>
                            <a href="https://ico.org.uk" target="_blank">
                                <v-img
                                        :src="icoLogo"
                                        width="150"
                                        height="101"
                                        class="mt-3"
                                ></v-img>
                            </a>
                        </div>
                        <div>
                            <a v-if="brand !== 'neotag'" href="https://www.realweather.co.uk/forecast/" target="_blank">
                                <v-img
                                        :src="findmyweather"
                                        width="300"
                                        height="62"
                                        class="mt-6"
                                ></v-img>
                            </a>
                        </div>
                    </div>
                </v-col>
                <v-col xs="6" sm="4" md="2">
                    <v-list
                            flat
                            style="background-color: transparent;"
                            dark
                            dense
                    >
                        <v-list-item @click="navigate('sign-up')">
                            {{ $t('menu.Sign up') }}
                        </v-list-item>
                        <v-list-item @click="navigate('products')">
                            {{ $t('menu.Shop') }}
                        </v-list-item>
                        <v-list-item @click="navigate('how-it-works')">
                            {{ $t('menu.How it works') }}
                        </v-list-item>
                        <v-list-item @click="navigate('environment')">
                          {{ $t('menu.Environment') }}
                        </v-list-item>
                        <v-list-item @click="navigate('contact-us')">
                            {{ $t('menu.Contact us') }}
                        </v-list-item>
                    </v-list>
                </v-col>
                <v-col xs="6" sm="4" md="2">
                    <v-list
                            flat
                            style="background-color: transparent;"
                            dark
                            dense
                    >
                        <v-list-item @click="navigate('cookies')">
                            {{ $t('menu.Cookie declaration') }}
                        </v-list-item>
                        <v-list-item @click="navigate('privacy-policy')">
                            {{ $t('menu.Privacy policy') }}
                        </v-list-item>
                        <v-list-item @click="navigate('terms-and-conditions')">
                          {{ $t('menu.Terms and conditions') }}
                        </v-list-item>
                    </v-list>
                </v-col>
                <v-col xs="12" sm="4" md="2" class="text-right">
                    <v-btn
                        v-if="brand === 'neotag'"
                        color="#fff"
                        class="white--text social"
                        fab
                        icon
                        small
                        href="https://www.facebook.com/neotagspain"
                        target="_blank"
                    >
                        <v-icon>mdi-facebook</v-icon>
                    </v-btn>
                    <v-btn
                        v-else
                        color="#fff"
                        class="white--text social"
                        fab
                        icon
                        small
                        href="https://www.facebook.com/FindMyKit"
                        target="_blank"
                    >
                      <v-icon>mdi-facebook</v-icon>
                    </v-btn>
                    <v-btn
                        v-if="brand === 'findmykit'"
                        color="#fff"
                        class="white--text social"
                        fab
                        icon
                        small
                        href="https://www.instagram.com/findmykitofficial"
                        target="_blank"
                    >
                      <v-icon>mdi-instagram</v-icon>
                    </v-btn>
                    <v-btn
                        v-if="brand === 'findmykit'"
                        color="#fff"
                        class="white--text social"
                        fab
                        icon
                        small
                        href="https://www.linkedin.com/company/findmykit-com"
                        target="_blank"
                    >
                      <v-icon>mdi-linkedin</v-icon>
                    </v-btn>
<!--                    <v-btn-->
<!--                        v-if="brand === 'neotag'"-->
<!--                        color="#fff"-->
<!--                        class="white&#45;&#45;text social"-->
<!--                        fab-->
<!--                        icon-->
<!--                        small-->
<!--                        href="https://twitter.com/neotagspain"-->
<!--                        target="_blank"-->
<!--                    >-->
<!--                        <v-icon>mdi-twitter</v-icon>-->
<!--                    </v-btn>-->
<!--                    <v-btn-->
<!--                        v-else-->
<!--                        color="#fff"-->
<!--                        class="white&#45;&#45;text social"-->
<!--                        fab-->
<!--                        icon-->
<!--                        small-->
<!--                        href="https://twitter.com/findmykit"-->
<!--                        target="_blank"-->
<!--                    >-->
<!--                      <v-icon>mdi-twitter</v-icon>-->
<!--                    </v-btn>-->
                    <v-btn
                        color="#fff"
                        class="white--text social"
                        fab
                        icon
                        small
                        href="https://www.youtube.com/channel/UCjNqynJSSu8vD5BjPPWy-HA"
                        target="_blank"
                    >
                      <v-icon>mdi-youtube</v-icon>
                    </v-btn>
                </v-col>
            </v-row>
            <v-row v-if="brand === 'findmykit'">
                <v-col>
                    <v-sheet
                            class="mx-auto rounded-xl white"
                            width="100%"
                    >
                        <div class="d-flex flex-column flex-sm-row justify-center align-center" style="width: 100%">

                            <div>
                                <a :href="playLink" target="_blank">
                                    <v-img
                                            :src="require('@/assets/google-play.png')"
                                            width="225"
                                            class="ma-1 ma-sm-6"
                                    >
                                    </v-img>
                                </a>
                            </div>
                            <div>
                                <a :href="iosLink" target="_blank">
                                    <v-img
                                            :src="require('@/assets/ios-download-black.png')"
                                            width="200"
                                            class="ma-1 ma-sm-6"
                                    >
                                    </v-img>
                                </a>
                            </div>
                        </div>
                    </v-sheet>

                </v-col>
            </v-row>
        </v-container>


    </v-footer>
</template>

<script>

    import {mapState} from "vuex";

    let findmyweather = require('@/assets/findmyweatherlogowhite.png')
    let icoLogo = require('@/assets/icologonobackgroundwhite.png')

    export default {
        name: "Footer",
        data () {
            return {
                findmyweather: findmyweather,
                icoLogo: icoLogo
            }
        },
        methods: {
            navigate (routeName) {
                this.$router.push({name: routeName})
            },
        },
        computed: {
          ...mapState({
            brand: state => state.brand,
            brandName: state => state.brandName,
          }),
          playLink() {
            if (this.brand === 'neotag') {
              return 'https://play.google.com/store/apps/details?id=neotagApp.expo'
            }
            else {
              return 'https://play.google.com/store/apps/details?id=findmykitScanningApp.expo'
            }
          },
          iosLink() {
            if (this.brand === 'neotag') {
              return 'https://apps.apple.com/gb/app/id1662911631'
            }
            else {
              return 'https://apps.apple.com/gb/app/id1527760767'
            }
          },
          footerColour() {
            if (this.brand === 'neotag') {
              return '#1E1E1E'
            }

            return '#1B1464'
          },
        }
    }
</script>

<style scoped>
    .social:hover {
        text-decoration: none;
    }
</style>
